import { useModal } from './useModal';
import { useContent } from '../redux/reducer/content';
import useStateControls from './useStateControls';
import { nyTaskContent } from '../constants/copyright';

const {
  tutorial,
  quiz: { button },
} = nyTaskContent;

export const useNyTaskCallbacks = ({ callbacks, setQuizScore, setActiveItem, setButtonId, activeItem }) => {
  const {
    quizQuests: { activeQuiz },
  } = useContent();

  const { addModal, closeModal } = useModal();

  const { setState } = useStateControls();

  const reset = () => {
    setQuizScore([]);
    setActiveItem(0);
    setButtonId('');
    callbacks.setActiveQuizQuest(null);
    closeModal('all');
  };

  const otherCallbacks = {
    setScore(id) {
      if (activeItem === activeQuiz?.questions?.length) return;
      setQuizScore((prev) => [...prev, id]);
    },
    nextStep() {
      if (activeItem === activeQuiz?.questions?.length - 1) return;
      setActiveItem((prev) => ++prev);
    },
    pause() {
      addModal({ type: 'pauseModal', props: { backFunc: reset } });
    },
    setActive(uid) {
      callbacks.setActiveQuizQuests(uid);
    },
    getQuestTaskState({ isCompleted, isAvailable }) {
      const states = {
        isAvailable: isAvailable && !isCompleted,
        isCompleted: isCompleted,
        isClosed: !isAvailable,
      };

      return Object.entries(states).reduce(
        (acc, [key, value]) => (acc !== 'default' ? acc : !!value ? key : acc),
        'default',
      );
    },
    buttonClick(action) {
      ({
        openInfo: () => addModal({ type: 'tutorialTaskModal', props: tutorial }),
        back: () => setState('main'),
      })[action]?.();
    },
    openQuizModal(quiz) {
      const goToQuiz = () => {
        closeModal({ type: 'all' });
        callbacks.setActiveQuizQuest(quiz);
      };
      addModal({ type: 'quizStartModal', props: { ...quiz, button, isBought: true, goToQuiz } });
    },
  };

  return { ...otherCallbacks, reset };
};
